import { RingModel } from '@/app/[locale]/product/_enums/RingModel';
import { RingFinish } from '@/app/[locale]/product/_steps/enums/RingFinish';
import { POP_PATHNAME } from '@/app/consts/pathnames';

export const SHOP_LINK_ID = 'oura-ring';
export const SALE_LINK_ID = 'sale';

export const GEN3_POP_PATHNAME = `${POP_PATHNAME}/${RingModel.Gen3}`;
export const OURA_RING_4_WIZARD_SUBPATH = `${RingModel.Oura4}/${RingFinish.Silver}`;
